import { defineMessages } from "react-intl";

import { node as combinedOrganTransplantation } from "src/modules/ktx/forms/basic-registration-data/clinical-data/pre-immunisation/combinedOrganTransplantation";
import { node as pregnanciesAndChildren } from "src/modules/ktx/forms/basic-registration-data/clinical-data/pre-immunisation/pregnanciesAndChildren";
import { node as previousOtherOrganTransplantation } from "src/modules/ktx/forms/basic-registration-data/clinical-data/pre-immunisation/previousOtherOrganTransplantation";
import { node as transfusion } from "src/modules/ktx/forms/basic-registration-data/clinical-data/pre-immunisation/transfusion";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "ktx.pre_immunisation",
		defaultMessage: "Előzetes immunizáltság"
	}
});

export const node: ParentNode = {
	id: "ktx-pre-immunisation",
	value: { type: "wizard", title: messages.title },
	children: [
		previousOtherOrganTransplantation,
		combinedOrganTransplantation,
		pregnanciesAndChildren,
		transfusion
	]
};
